
import React from 'react'
import { Col, Row } from 'react-bootstrap'

import { useProject } from '@/Hooks/UseProject'

import './ContentBody.scss'

interface Props {
  noScroll?: boolean
  noPaddingBottom?: boolean
  children: React.ReactNode
}

const ContentBody = ({ noScroll, noPaddingBottom, children }: Props) => {

  const { project } = useProject()

  const clases = [
    'content-body',
    'ul-widget__body',
    'scroller',
    noPaddingBottom && 'no-padding-bottom'
  ]

  if (project._id) clases.push('with-footer')
  if (noScroll) clases.push('no-scroll')

  return (
    <div
      className={clases.join(' ')}
    >
      <Row style={{ margin: 0, height: '100%' }}>
        <Col className='' style={{ height: '100%' }}>
          {children}
        </Col>
      </Row>
    </div>
  )
}

export default ContentBody
